import store from "@/store"
function throttle(fn, delay = 100) {
	let timer = null
	
	return function() {
		if (timer) {
			return
		}
		timer = setTimeout(() => {
			fn.apply(this, arguments)
			timer = null
		}, delay)
	}
}
window.onload = () => {
	store.commit('setWindowWidth',window.innerWidth)
	window.onresize = throttle(() => {
		store.commit('setWindowWidth',window.innerWidth)
	})
}